import Vue from 'vue'
import Router from 'vue-router'
import { sync } from 'vuex-router-sync'
import store from '../store'
import routes from './routes'
import Meta from 'vue-meta'

Vue.use(Meta)
Vue.use(Router)

const router = make(
	routes()
)

sync(store, router)

export default router

/**
 * Create new router instance.
 *
 * @param  {Array} routes
 * @return {Router}
 */
function make (routes) {
	const router = new Router({
		mode: 'history',
		hashbang: false,
		base: __dirname,
		linkActiveClass: 'active',

		routes,
		scrollBehavior
	})

	router.beforeEach(async (to, from, next) => {
    if (to.path === '/login') {
      try {
        $('.ui.modal').modal('hide');
      } catch (e) {

      }
    }
    setLayout(router, to)
		next()
	})

	// Register after hook.
	router.afterEach((to, from) => {
		router.app.$nextTick(() => {
			router.app.$loading.finish()
		})
	})

	return router
}

/**
 * Set the application layout from the matched page component.
 *
 * @param {Router} router
 * @param {Route} to
 */
function setLayout (router, to) {
	// Get the first matched component.
	const [component] = router.getMatchedComponents({ ...to })

	if (component) {
		router.app.$nextTick(() => {
			// Start the page loading bar.
			if (component.loading !== false) {
				router.app.$loading.start()
			}

			// Set application layout.
			router.app.setLayout(component.layout || '')
		})
	}
}

/**
 * @param  {Route} to
 * @param  {Route} from
 * @param  {Object|undefined} savedPosition
 * @return {Object}
 */
function scrollBehavior (to, from, savedPosition) {
	if (savedPosition) {
		return savedPosition
	}

	const position = {}

	if (to.hash) {
		position.selector = to.hash
	}

	if (to.matched.some(m => m.meta.scrollToTop)) {
		position.x = 0
		position.y = 0
	}

	return position
}



// WEBPACK FOOTER //
// ./src/router/index.js